export type AsyncState<T> =
  | { status: "idle" | "loading"; data: null; error: null }
  | { status: "success"; data: T; error: null }
  | { status: "empty"; data: null; error: null }
  | { status: "error"; data: null; error: Error };

export function toError(error: unknown): Error {
  return error instanceof Error ? error : new Error("Unknown error");
}
